import Clients1 from './Clients1'
export default Clients1
